import { createRoot } from 'react-dom/client'
import './index.css'
import { Logo } from '@pmndrs/branding'
import ReactPlayer from 'react-player'
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import Archive from './Archive'
import Home from './Home'
import { useMediaQuery } from 'react-responsive'

function Root() {
  const isDesktop = useMediaQuery({
    query: '(min-width: 640px)',
  })

  return (
    <div 
      className="absolute top-0 left-0 w-screen h-screen bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: isDesktop ? 'none' : "url('/bg-mobile.jpeg')"
      }}
    >
      <div className="fixed bottom-5 right-5 z-50">
        <img width="100px" src="/work_.png" alt="Logo" />
      </div>
      
      <div className="w-full h-full">
        <Router 
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <div className="w-full h-full">
            <nav className="fixed top-5 font-semibold z-50 flex flex-row justify-center items-center w-screen gap-10">
              <div className="relative">
                <Link 
                  className="text-black transition duration-300 hover:text-white text-shadow-md hover:text-shadow-none" 
                  to="/"
                >
                  home
                </Link>
              </div>
              <div className="relative">
                <a
                  className="text-black transition duration-300 hover:text-white text-shadow-md hover:text-shadow-none"
                  href="https://www.org123.xyz/categories/nul1org"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  shop
                </a>
              </div>
              <div className="relative">
                <Link 
                  className="text-black transition duration-300 hover:text-white text-shadow-md hover:text-shadow-none" 
                  to="/archive"
                >
                  archive
                </Link>
              </div>
              <div className="relative">
                <a
                  className="text-black transition duration-300 hover:text-white text-shadow-md hover:text-shadow-none"
                  href="https://www.instagram.com/nul1org/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  instagram
                </a>
              </div>
            </nav>
            
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/archive" element={<Archive />} />
            </Routes>
          </div>
        </Router>
      </div>
    </div>
  )
}

createRoot(document.getElementById('root')).render(<Root />)